var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGraphDataTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1C22.0357 1 22.887 1.78722 22.9893 2.7959L23 3V20.5C23 21.6046 22.1046 22.5 21 22.5H4L3.7959 22.4893C2.85435 22.3938 2.1062 21.6457 2.01074 20.7041L2 20.5V3L2.01074 2.7959C2.1062 1.85435 2.85435 1.1062 3.7959 1.01074L4 1H21ZM9.5 21H21C21.2761 21 21.5 20.7761 21.5 20.5V17.5H9.5V21ZM3.5 20.5C3.5 20.7761 3.72386 21 4 21H8V17.5H3.5V20.5ZM9.5 16H21.5V12.5H9.5V16ZM3.5 16H8V12.5H3.5V16ZM9.5 11H21.5V7.5H9.5V11ZM3.5 11H8V7.5H3.5V11ZM9.5 6H21.5V3C21.5 2.72386 21.2761 2.5 21 2.5H9.5V6ZM4 2.5C3.72386 2.5 3.5 2.72386 3.5 3V6H8V2.5H4Z",
    fill: "#282D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphDataTable);
export default __webpack_public_path__ + "static/media/icon-graph-dataTable.e1fe38ff26d3ecf51c02d7e3b50fe40c.svg";
export { ForwardRef as ReactComponent };